import type { ReactNode } from 'react';

export const symbol_motion_photos_on: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-34 5.5-67.01Q91-580.02 102-612q4-11 15-14.5t21 2.8q10.71 6.3 15.36 18.5Q158-593 155-581q-6 25-10.5 50.15Q140-505.71 140-480q0 142.37 99 241.19Q338-140 480-140t241-98.81q99-98.82 99-241.19 0-142.38-98.81-241.19T480-820q-27.57 0-54.57 4T372-804q-12 4-24-1t-17-16q-5-11 1-22t17-15q31-10 63-16t64-6q83 0 156.5 31.5T760.95-763q54.94 54 87 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80ZM177.5-713.62q-14.5-14.62-14.5-35.5 0-20.88 14.62-35.38 14.62-14.5 35.5-14.5 20.88 0 35.38 14.62 14.5 14.62 14.5 35.5 0 20.88-14.62 35.38-14.62 14.5-35.5 14.5-20.88 0-35.38-14.62ZM480-480Z"
		/>
	</svg>
);
